export default function (postalCode, loginKey) { 
  return `query GetIQuoteId { 
    login(zip: "${postalCode}", loginCode: "${loginKey}") {
      accessToken
    }
  }`
}
